import { ReactNode } from 'react';
import { Stack } from 'components';

type RootProps = {
  children: ReactNode;
};

export const Root = ({ children }: RootProps) => {
  return (
    <Stack width="100%" display="flex" gap="28px" data-test-id="profile-notes-form">
      {children}
    </Stack>
  );
};
